import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Card, Nav, Button, Row, Col } from 'react-bootstrap';
import { objectGiaiDoanDaoTaoUITabs, giaiDoanDaoTaoUITabsValue } from '@app/utils/define';

import HoiDongDaoDuc from '../hoiDongDaoDuc/HoiDongDaoDuc';
import SoLieuNghienCuuTab from '../soLieuNghienCuu/SoLieuNghienCuuTab';
import HocPhanTienSiTab from '../hocPhanTienSi/HocPhanTienSiTab';
import BaoVeCoSo from '../baoVeCoSo/BaoVeCoSo';
import PhanBienDocLap from '../phanBienDocLap/PhanBienDocLap';
import BaoVeCapVien from '../baoVeCapVien/BaoVeCapVien';

import { useTrangThaiGiaiDoan } from './UseTrangThaiGiaiDoan';

const GiaiDoanDaoTaoNCS = () => {
    const history = useHistory();
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState(giaiDoanDaoTaoUITabsValue.hoiDongDaoDuc);
    const completedStages = useTrangThaiGiaiDoan(id);

    const handleGoBack = () => {
        history.goBack();
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case giaiDoanDaoTaoUITabsValue.hoiDongDaoDuc:
                return <HoiDongDaoDuc hoSoId={id} />;
            case giaiDoanDaoTaoUITabsValue.soLieuNghienCuu:
                return <SoLieuNghienCuuTab hoSoId={id} />;
            case giaiDoanDaoTaoUITabsValue.hocPhanTienSiTab:
                return <HocPhanTienSiTab hoSoId={id} isAdmin={false} />;
            case giaiDoanDaoTaoUITabsValue.baoVeCapCoSo:
                return <BaoVeCoSo hoSoId={id} />;
            case giaiDoanDaoTaoUITabsValue.phanBienDocLap:
                return <PhanBienDocLap hoSoId={id} />;
            case giaiDoanDaoTaoUITabsValue.baoVeCapVien:
                return <BaoVeCapVien hoSoId={id} />;
            default:
                return (
                    <div className="text-center p-5">
                        <h5>Tính năng đang được phát triển...</h5>
                    </div>
                );
        }
    };

    return (
        <div className="container-fluid">
            <Card className="mb-3 shadow-sm border-0" style={{ backgroundColor: '#f0f2f5' }}>
                <Card.Body className="p-3">
                    <Row className="mx-n1 mb-n2">
                        {objectGiaiDoanDaoTaoUITabs.map((stage) => (
                            <Col md={4} key={stage.value} className="px-1 mb-2">
                                <div 
                                    className={`h-100 w-100 d-flex align-items-center justify-content-center text-center py-1 px-2 rounded btn ${
                                        activeTab === stage.value 
                                            ? (completedStages[stage.value] ? 'btn-success text-white border-dark shadow-sm' : 'btn-primary text-white shadow-sm')
                                            : (completedStages[stage.value] ? 'btn-success text-white shadow-sm' : 'btn-light text-dark border')
                                    }`}
                                    onClick={() => setActiveTab(stage.value)}
                                    style={{ cursor: 'pointer', minHeight: '32px', transition: 'all 0.2s ease' }}
                                >
                                    <span className="font-weight-bold" style={{ fontSize: '1rem', lineHeight: '1.2' }}>{stage.label}</span>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Card.Body>
            </Card>

            <div style={{ minHeight: 'calc(100vh - 300px)' }}>
                {renderTabContent()}
            </div>
        </div>
    );
};

export default GiaiDoanDaoTaoNCS;

